import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  form: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  //color: ThemePalette = 'primary';
  error: any;
  selectedLang: number = 1;
  lang: { id: number, name: string }[] = [];
  spinnerOverlay = false
  hidePassword = true;

  constructor(private router: Router,
    private service: AuthService,
    private snackBar: MatSnackBar,
    private localStorage: LocalStorageService,
    private translate: TranslateService) {
    this.translate.setDefaultLang('ar');
    this.translate.use('ar');
  }

  ngOnInit(): void {
    this.lang = [{ id: 1, name: 'عربي' }, { id: 0, name: 'English' }];
    if (this.localStorage.retrieve("lang") != null) {
      this.selectedLang = this.localStorage.retrieve("lang");
    }
    this.selectedLang == 1 ? this.translate.use('ar') : this.translate.use('en');
    this.selectChange();
  }

  submit() {
    this.spinnerOverlay = true;
    this.service.login(this.form.value).subscribe(data => {

      this.localStorage.store("token", data["token"]);
      this.localStorage.store("userInfo", data);
      this.router.navigate(['master']);
      this.spinnerOverlay = false;
    }, error => {
      console.log(error);
      if (error.error.messageAr != null && error.error.messageAr != undefined) {
        this.openSnackBar(error.error.messageAr, 'snackBarError');
      }
      else {
        this.openSnackBar(error.error.message, 'snackBarError');
      }
      this.spinnerOverlay = false;
    });

  }


  selectChange() {
    var body = document.getElementsByTagName('body')[0];
    var html = document.getElementsByTagName('html')[0];
    body.removeAttribute("dir");
    html.removeAttribute("dir");

    this.selectedLang == 0 ? this.translate.use('en') : this.translate.use('ar');
    if (this.selectedLang == 0) {

      body.setAttribute("dir", "ltr");
      html.setAttribute("dir", "ltr");
    }
    else {
      body.setAttribute("dir", "rtl");
      html.setAttribute("dir", "rtl");
    }

    this.localStorage.store("lang", this.selectedLang);

  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

}
